import React, { Component } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faWindowClose,
  faPen
} from '@fortawesome/free-solid-svg-icons';

import KarteStore from '../../store';
import { Format, SheetFormat } from '../../types';
import Map from '../Map';
import LineChart from '../LineChart';
import BarChart from '../BarChart';

type Props = {
  karteStore: KarteStore;
  karteIndex: number;
};

const components: Record<
  Format,
  React.ComponentType<{
    karteStore: KarteStore;
    karteIndex: number;
  }>
> = {
  [Format.Map]: Map,
  [Format.Similarity]: Map,
  [Format.LineChart]: LineChart,
  [Format.BarChart]: BarChart
};

@observer
class Viewer extends Component<Props> {
  render() {
    const index = this.props.karteIndex;
    const karte = this.props.karteStore.getKarte(this.props.karteIndex);
    const Component = components[karte.format];
    const wasAdministrationChange = karte.area?.includes('変更前');
    return (
      <Wrapper>
        {Component ? (
          <>
            <Component karteIndex={index} karteStore={this.props.karteStore} />
            {this.props.karteStore.sheetFormat !== SheetFormat.Template && (
              <>
                <EditButton onClick={this.handleClickEdit}>
                  <FontAwesomeIcon icon={faPen} size="1x" />
                </EditButton>
                <EditDesc className="edit-desc-text">
                  選択項目を変更する
                </EditDesc>
                <CloseButton
                  onClick={this.props.karteStore.removeKarte.bind(
                    this,
                    this.props.karteIndex
                  )}
                >
                  <FontAwesomeIcon icon={faWindowClose} size="1x" />
                </CloseButton>
                <CloseDesc className="close-desc-text">
                  閲覧中の選択項目をリセットする
                </CloseDesc>
              </>
            )}
          </>
        ) : (
          <StyledButton
            onClick={this.props.karteStore.showAdditionalModal.bind(
              this,
              this.props.karteIndex
            )}
          >
            <FontAwesomeIcon icon={faPlus} size="3x" />
          </StyledButton>
        )}
        {wasAdministrationChange && (
          <AreaDataCaution>
            ＊この地域は過去に行政変更が行われた地域です。
          </AreaDataCaution>
        )}
      </Wrapper>
    );
  }

  handleClickEdit = () => {
    const karteStore = this.props.karteStore;
    karteStore.showAdditionalModal(this.props.karteIndex);
  };
}

const Wrapper = styled.div`
  flex: 1;
  background: #fff;
  justify-content: center;
  align-items: center;
  padding: 3px;
  position: relative;
`;

const StyledButton = styled.button`
  width: 100%;
  height: 100%;
  border: dashed 2px #999;
  border-radius: 5px;
  background: #fff;
  color: #999;
  cursor: pointer;
`;

const ButtonStyle = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  text-align: center;
  align-items: center;
  position: absolute;
  border: none;
  border-radius: 2px;
  background: '#fff';
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
  color: #999;
  font-size: 16px;
  cursor: pointer;
  z-index: 900;
`;

const EditButton = styled(ButtonStyle)`
  top: 46px;
  right: 18px;
  &:hover + .edit-desc-text {
    display: block;
  }
`;

const CloseButton = styled(ButtonStyle)`
  top: 18px;
  right: 18px;
  &:hover + .close-desc-text {
    display: block;
  }
`;

const IconDescStyle = styled.p`
  font-size: 12px;
  padding: 8px 20px;
  border-radius: 3px;
  display: none;
  color: #fff;
  position: absolute;
  right: 0px;
  z-index: 950;
  background: rgba(0, 0, 0, 0.8);
  &:after {
    position: absolute;
    width: 0;
    height: 0;
    right: 20px;
    top: -20px;
    border: solid transparent;
    border-bottom-color: rgba(0, 0, 0, 0.8);
    border-width: 10px;
    pointer-events: none;
    content: ' ';
  }
`;

const CloseDesc = styled(IconDescStyle)`
  top: 60px;
`;

const EditDesc = styled(IconDescStyle)`
  top: 84px;
`;

const AreaDataCaution = styled.p`
  font-size: 10px;
  position: absolute;
  bottom: 5px;
  right: 5px;
  z-index: 1001;
  background: rgba(211, 211, 211, 0.4);
  padding: 5px;
`;

export default Viewer;
